import ProposalItem from './ProposalItem';
export default ProposalItem;
